import { BehaviorSubject } from 'rxjs';

const query$ = new BehaviorSubject({ status: false });

export const changeTo = (status) => query$.next({ status });
export const subscribe = (callback) => query$.subscribe(callback);
export const unsubscribe = (subscription) => subscription.unsubscribe();
